"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var format_exports = {};
__export(format_exports, {
  formatLatLng: () => formatLatLng,
  formatNgr: () => formatNgr,
  ngrToPoint: () => ngrToPoint,
  parseLatLng: () => parseLatLng,
  pointToNgr: () => pointToNgr,
  pointToPrecision: () => pointToPrecision,
  safeFormatNgr: () => safeFormatNgr,
  safePointToNgr: () => safePointToNgr
});
module.exports = __toCommonJS(format_exports);
var import_position = require("../position/index.js");
var import_create = require("./create.js");
const defaultGpsDigits = 6;
const defaultNgrDigits = 10;
function pointToPrecision(p, digits = defaultGpsDigits) {
  const [lon, lat] = p.coordinates;
  return (0, import_create.point)(Number.parseFloat(lon.toFixed(digits)), Number.parseFloat(lat.toFixed(digits)));
}
function formatLatLng(p, digits = defaultGpsDigits, separator = ", ") {
  const [lon, lat] = p.coordinates;
  return `${lat.toFixed(digits)}${separator}${lon.toFixed(digits)}`;
}
const ORDINAL_REGEX = /^-?\d+(\.\d+)?$/;
function parseLatLng(value, separator = ",") {
  const parts = value.split(separator).map((part) => part.trim());
  if (parts.length !== 2) return null;
  try {
    const latitudeString = parts[0];
    if (!ORDINAL_REGEX.test(latitudeString)) return null;
    const longitudeString = parts[1];
    if (!ORDINAL_REGEX.test(longitudeString)) return null;
    const latitude = Number.parseFloat(latitudeString);
    if (latitude < -90 || latitude > 90) return null;
    const longitude = Number.parseFloat(longitudeString);
    if (longitude < -180 || longitude > 180) return null;
    return {
      type: "Point",
      coordinates: [longitude, latitude]
    };
  } catch (e) {
    return null;
  }
}
function ngrToPoint(value) {
  try {
    const osgb = (0, import_position.ngrToOsgb36)(value);
    if (osgb == null) {
      return void 0;
    } else {
      const wgs = (0, import_position.osgb36ToWgs84)(osgb);
      return pointToPrecision((0, import_create.createPoint)(wgs));
    }
  } catch (e) {
    return void 0;
  }
}
function pointToNgr(point2, digits = defaultNgrDigits, spaces = true) {
  try {
    return (0, import_position.osgb36ToNgr)((0, import_position.wgs84ToOsgb36)(point2.coordinates), digits, spaces);
  } catch (error) {
    return void 0;
  }
}
function safePointToNgr(point2, digits = defaultNgrDigits, spaces = true) {
  return pointToNgr(point2, digits, spaces) ?? "Outside of the UK";
}
function formatNgr(ngr, digits = defaultNgrDigits, spaces = true) {
  try {
    const osgb = (0, import_position.ngrToOsgb36)(ngr);
    if (osgb == null) {
      return void 0;
    } else {
      return (0, import_position.osgb36ToNgr)(osgb, digits, spaces);
    }
  } catch (error) {
    return void 0;
  }
}
function safeFormatNgr(ngr, digits = 10, spaces = true) {
  return formatNgr(ngr, digits, spaces) ?? "Outside of the UK";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  formatLatLng,
  formatNgr,
  ngrToPoint,
  parseLatLng,
  pointToNgr,
  pointToPrecision,
  safeFormatNgr,
  safePointToNgr
});
//# sourceMappingURL=format.js.map
